import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, requireTos = true }) => {
    const { user, userProfile } = useAuth();

    if (!user) {
        return <Navigate to="/login" />;
    }

    // If ToS is required, profile exists, and ToS not accepted → redirect
    if (requireTos && userProfile && !userProfile.tos_accepted_at) {
        return <Navigate to="/accept-tos" />;
    }

    return children;
};
